/**
 * @generated SignedSource<<40f39e4f0fececae283d2f5d3b0bf42f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ForAgainstAbstainRowFragment$data = {
  readonly delegateMetrics: {
    readonly againstVotes: number;
    readonly forVotes: number;
  };
  readonly " $fragmentType": "ForAgainstAbstainRowFragment";
};
export type ForAgainstAbstainRowFragment$key = {
  readonly " $data"?: ForAgainstAbstainRowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ForAgainstAbstainRowFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ForAgainstAbstainRowFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DelegateMetrics",
      "kind": "LinkedField",
      "name": "delegateMetrics",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forVotes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "againstVotes",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Delegate",
  "abstractKey": null
};

(node as any).hash = "1c3ce3d6f9ebb51fcc654ff12123b512";

export default node;
